<template>

  <Header />
  <div id="app">
    <router-view />
<!-- <p>Hola {{$store.state.numeroDocumento}}</p> -->
  </div>
  <Footer />
</template>

<script>

import Header from "./components/Header/Header.vue";
import Footer from "./components/Footer.vue";
// import axios from 'axios'

export default {
  components: {
    Header,
    Footer,
  },
 

}



</script>
<style lang="scss">
</style>
